import React from "react";
import { Table } from "../../../../data-table/Table";
import { CSVLink } from "react-csv";
import { Link } from "react-router-dom";
import { Typography } from "@material-ui/core";
import GPAP_BUTTON from "../../../../../gpap-lib/Button_Collection";
import "../../../custom_material_ui_like.css";

// TODO
// fallback to redirect to /home if someone navigates to
// "/filesubmitted" or "/datasetsubmitted" /analysissubmitted

export class SummaryInserted extends React.Component {
  render() {
    return (
      <div className={"mainContent"}>
        <Typography variant={"h5"} align={"center"}>
          {" "}
          project: {this.props.location.projectId}
        </Typography>
        <Typography variant={"h5"} align={"center"}>
          {" "}
          Submission Successful!{" "}
        </Typography>
        <Typography variant={"h6"} align={"center"}>
          Summary of your Submission
        </Typography>
        <div className="col-md-auto d-flex justify-content-start">
          <CSVLink
            className="custom_mui_button"
            data={this.props.location.tableContents}
            filename={this.props.location.filename}
          >
            DOWNLOAD AS CSV
          </CSVLink>
          {this.props.location.nextPage !== "" ? (
            <GPAP_BUTTON
              to={{
                pathname: this.props.location.nextPage,
                projectId: this.props.location.projectId,
              }}
              component={Link}
            >
              {" "}
              {this.props.location.nextPageLabel}
            </GPAP_BUTTON>
          ) : null}
        </div>

        {/* TODO: redirect to /home when "this.props.tableContents is undefined  */}
        <Table tableContents={this.props.location.tableContents} />
      </div>
    );
  }
}
